define(['underscore','text!./templates/ownership-address.html'],
    (_,templateStr) => {
    return ['AddressStandardizationService', '$q', 'ModalService','LocaleService', (AddressStandardizationService, $q, ModalService,LocaleService) => {
        return {
            restrict: 'A',
            template: templateStr,
            scope: {
                address : '=',
                lease: '=',
                readonly: '=',
                vehicles: '=',
            },
            controller:['$scope', ($scope) => {
                //console.log("Teeee ", $scope.address);
                $scope.showLoading = false;
$scope.isFormSubmitted = false;
const defaultCountryCode = $scope.defaultCountryCode || LocaleService.getCountry().code;
$scope.address.country.value = defaultCountryCode;
$scope.$on('submit-form', ()=> {
$scope.isFormSubmitted = true;
});
$scope.getStandardAddress = () => {
    if ($scope.address.postalCode.value && $scope.address.postalCode.value.length > 0) {
        $scope.readonly = true;
        $scope.showLoading = true;
        $scope.State = '';

        $scope.standardAddressDetails = {
            streetAddress : $scope.address.addressLine1.value,
            extendedAddress : $scope.address.addressLine2.value,
            zipCode : $scope.address.postalCode.value

        };
        $q.when(AddressStandardizationService.standardAddress('addressstandardization', $scope.standardAddressDetails),
            (AddressResponse) => {

            // AddressResponse.streetAddress = undefined;
            // AddressResponse.streetAddress && AddressResponse.extendedAddress && AddressResponse.city && AddressResponse.state
            if (AddressResponse && AddressResponse.streetAddress && AddressResponse.city && AddressResponse.state) {
            //Autofill with the returned data
            //var title = "Title"
            var message = "Is this your correct Address?"
            var message2 = "We were unable to validate your address"
            var validationMessage = "No, proceed with address I entered"
            var validationMessage2 = "No, go back and edit"
            if(null != AddressResponse.extendedAddress){
                var address = AddressResponse.streetAddress + " " + AddressResponse.extendedAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
            }else {
                var address = AddressResponse.streetAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
            }
            var addressModel = ModalService.showAddressStandard(message,validationMessage,address)

            addressModel.result.then(function(result){
                if(result.actionType=="yes"){

                    $scope.address.addressLine1.value = AddressResponse.streetAddress;
                    $scope.address.addressLine2.value = AddressResponse.extendedAddress;
                    $scope.address.city.value = AddressResponse.city;
                    $scope.address.postalCode = AddressResponse.zipCode;
                    $scope.address.county = AddressResponse.county;
                    if($scope.address.addressLine1.value)
                    {
                        $scope.address.addressLine1.value = $scope.address.addressLine1.value.trim()
                    }

                    if($scope.address.addressLine2.value)
                    {
                        $scope.address.addressLine2.value = $scope.address.addressLine2.value.trim()
                    }

                    if(AddressResponse.state=='North Carolina' || AddressResponse.state == 'NC'){
                        // console.log("inside NC")
                        $scope.address.state.value  = 'NC';
                    }
                    else if (AddressResponse.state == 'South Carolina' || AddressResponse.state == 'SC'){
                        $scope.address.state.value = 'SC';
                    }else{
                        $scope.address.state.value = _.findWhere($scope.address.state.aspects.availableValues, {name: AddressResponse.state});
                    }
                    $scope.State = AddressResponse.state;
                    //$scope.State  = $scope.address.state.value
                    //  $scope.address.state.value = AddressResponse.state;

                }else{
                    $scope.readonly = false;
                    //$scope.State = $scope.address.state.value
                }

            }, function(){

            })

        } else {

            //Autofill with the returned data
            //var title = "Title"
            var message = "We were unable to validate your address"
            var validationMessage = "No, go back and edit"
            var address = "Would you like to proceed with the address you entered?"
            var addressModel = ModalService.showAddressStandard(message, validationMessage, address)
            addressModel.result.then(function(result){
                if (result.actionType == "yes"){
                    //Need to add code if yes is pressed
                }
            }, function(){

            })
            $scope.readonly = false;
            $scope.address.city.value = '';
            $scope.address.county.value = '';
            $scope.address.state.value = undefined;
        }
        $scope.showLoading = false;
    },
        () => {
            //Something has gone legitimately wrong, let the user input the data manually
            $scope.readonly = false;
            $scope.showLoading = false;
        });
    } else {
        $scope.readonly = false;
        $scope.address.city.value = '';
        $scope.address.county.value = '';
        $scope.address.state.value = undefined;
    }


};
}]
};
}];
}
);



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/addressstandardization/directives/OwnershipAddress.js
 **/